















































import { Component } from 'vue-property-decorator';
import CommonMixin from "@/utils/CommonMixin";
import cr from "@/CompositionRoot";
import _ from "lodash";
import { FeedItem, FeedItemGrid, FeedItems, ScheduleItemToShow } from "frontend-common";
import AddFeedItem from "@/components/dashboard/AddFeedItem.vue";
import { dateLocale } from "@/utils/date-utils";

@Component({
    components: {
        AddFeedItem,
    }
})
export default class extends CommonMixin {

    private currentFeedItems: FeedItems = []
    private dragIndex = -1

    created() {
        this.onReset()
    }

    mounted() {
        const route = this.$route
        const refs = this.$refs
        setTimeout(function () {
            if (!route.meta?.fromHistory) {
                (refs.add as HTMLElement).focus()
            }
        }, 100)

        this.bindShortcuts()
        this.addOnEscapeListener(() => this.$router.push(this.toEvent(this.uuid)))
    }

    get uuid(): string {
        return this.$route.params.uuid
    }

    get timeZone(): string {
        return this.$cr.myEventsModule.descriptionByUuid(this.uuid)!!.settings.timeZone
    }

    get feedItems(): FeedItems {
        return cr.myEventsModule.feedItemsByEvent(this.uuid)
    }

    onRowClicked(item: ScheduleItemToShow) {
        this.$router.push(this.toFeedItem(item.id))
    }

    startDrag(event: any) {
        this.dragIndex = event.oldIndex
    }

    endDrag() {
        this.dragIndex = -1
    }

    get hasChanges(): boolean {
        return !_.isEqual(this.currentFeedItems, _.clone(this.feedItems));
    }

    isEmpty(): boolean {
        return _.isEmpty(this.feedItems)
    }

    onFeedItemAdded(feedItem: FeedItem) {
        this.onReset()
        this.$bvModal.hide("add-feedItem")
        this.$router.push(this.toFeedItem(feedItem.id))
    }

    onFeedItemAddCancelled() {
        this.$bvModal.hide("add-feedItem")
    }

    onReset() {
        this.currentFeedItems = _.clone(this.feedItems)
    }

    get feedItemsForGrid(): Array<FeedItemGrid> {
        const statusDraft = this.$t("dashboard.feedItem.status.statusDraft") as string
        return this.feedItems.map(feedItem => {
            return FeedItemGrid.from(feedItem, statusDraft, this.toDateTime(feedItem.datePub))
        })
    }

    toDateTime(dateTime: number): string {
        const locale = dateLocale(this.$cr.i18n.locale)
        return new Date(dateTime).toLocaleString(locale, {
            timeZone: this.timeZone,
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        })
    }

    get visibleFields(): Array<string> {
        return FeedItemGrid.visibleFields()
    }
}
